import { LaunchType, LaunchTypeLabel } from '../../enums/ScheduleEnums';
import {
  LaunchTypeAutomatedIcon,
  LaunchTypeManualIcon,
  LaunchTypeCompleteIcon,
} from './LaunchTypeIcons';

function caseCountLabel(n) {
  return n === 1 ? '1 case' : `${n} cases`;
}

export const TYPE_OPTIONS = [
  {
    value: LaunchType.AUTOMATED,
    title: 'Automated tests',
    description: (n) => (n > 0 ? `Tests this platform runs — ${caseCountLabel(n)}` : 'No automated tests in this group'),
    countKey: 'automated',
    Icon: LaunchTypeAutomatedIcon,
  },
  {
    value: LaunchType.MANUAL,
    title: 'Manual tests',
    description: (n) => (n > 0 ? `Tests run by people or external systems — ${caseCountLabel(n)}` : 'No manual tests in this group'),
    countKey: 'manual',
    Icon: LaunchTypeManualIcon,
  },
  {
    value: LaunchType.COMPLETE,
    title: LaunchTypeLabel[LaunchType.COMPLETE],
    description: (n) => (n > 0 ? `Everything in this group — ${caseCountLabel(n)}` : 'No test cases in this group'),
    countKey: 'total',
    Icon: LaunchTypeCompleteIcon,
  },
];

export function includedCaseCount(launchType, testScope) {
  if (launchType === LaunchType.AUTOMATED) return testScope.automated || 0;
  if (launchType === LaunchType.MANUAL) return testScope.manual || 0;
  return testScope.total || 0;
}
